import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AddPopupComponent } from '../add-popup/add-popup.component';
import { faXmark, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
@Component({
  selector: 'app-expense-table',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, AddPopupComponent, FontAwesomeModule],
  templateUrl: './expense-table.component.html',
  styleUrl: './expense-table.component.css',
})
export class ExpenseTableComponent implements OnInit, OnChanges {
  faXmark = faXmark;
  faTrashCan = faTrashCan;
  showCategoryModal = false;
  showSubCategoryModal = false;
  isEditMode = false;
  showSkeleton = true;
  categoryForm: FormGroup;
  subCategoryForm: FormGroup;

  selectedSectionIndex!: number;
  selectedExpenseIndex!: number;
  selectedFileName: string | null = null;

  sections = [
    {
      title: 'Meals And Entertainment',
      isOpen: true,
      expense: [
        { title: 'Basic Policies 2025 to 2026', amount: '1500', date: '22-10-2022', attach: "clientDinner.png", status: "Paid" },
        { title: 'Basic Policies 2025 to 2026', amount: '1500', date: '22-10-2022', attach: "clientDinner.png", status: "Unpaid" },
        { title: 'Basic Policies 2025 to 2026', amount: '1500', date: '22-10-2022', attach: "clientDinner.png", status: "Paid" },
      ],
    },
    {
      title: 'Office Supplies',
      isOpen: false,
      expense: [
        {
          title: 'Printer Paper',
          amount: '800',
          date: '12-09-2022',
          attach: 'paper.png',
          status: 'Paid',
        },
      ],
    },
    {
      title: 'Utilities',
      isOpen: false,
      expense: [
        {
          title: 'Electricity Bill',
          amount: '5000',
          date: '05-10-2022',
          attach: 'bill.pdf',
          status: 'Paid',
        },
      ],
    },
    {
      title: 'Maintenance & Repairs',
      isOpen: false,
      expense: [
        {
          title: 'AC Repair',
          amount: '3000',
          date: '18-10-2022',
          attach: 'repair.png',
          status: 'Unpaid',
        },
      ],
    },
  ];

  constructor(private fb: FormBuilder) {

    this.categoryForm = this.fb.group({
      title: ['', Validators.required]
    });

    this.subCategoryForm = this.fb.group({
      title: ['', Validators.required],
      amount: ['', Validators.required],
      date: ['', Validators.required],
      status: ['Paid', Validators.required],
      attachment: [null]
    });
  }

  // CATEGORY
  toggleCategoryModal() {
    this.showCategoryModal = !this.showCategoryModal;
    if (!this.showCategoryModal) {
      this.categoryForm.reset();
    }
  }

  onSaveCategory() {
    if (this.categoryForm.valid) {
      this.sections.push({
        title: this.categoryForm.value.title,
        isOpen: true,
        expense: []
      });
      this.toggleCategoryModal();
    }
  }

  // SUB CATEGORY
  openAddSubCategory(sectionIndex: number) {
    this.isEditMode = false;
    this.selectedSectionIndex = sectionIndex;
    this.showSubCategoryModal = true;
  }

  openEditSubCategory(item: any, sectionIndex: number, expenseIndex: number) {
    this.isEditMode = true;
    this.selectedSectionIndex = sectionIndex;
    this.selectedExpenseIndex = expenseIndex;
    this.showSubCategoryModal = true;
    const formattedDate = this.convertToInputDateFormat(item.date);
    this.subCategoryForm.patchValue({
      title: item.title,
      amount: item.amount,
      date: formattedDate,
      status: item.status
    });

    this.selectedFileName = item.attach || null;
  }

  convertToInputDateFormat(dateString: string): string {
    if (!dateString) return '';
    const parts = dateString.split('-');
    if (parts.length === 3) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    return dateString;
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.subCategoryForm.patchValue({ attachment: file });
      this.selectedFileName = file.name;
    }
  }

  onFileDropped(event: DragEvent) {
    event.preventDefault();

    if (event.dataTransfer?.files.length) {
      const file = event.dataTransfer.files[0];
      this.subCategoryForm.patchValue({ attachment: file });
      this.selectedFileName = file.name;
    }
  }
  toggleSubCategoryModal() {
    this.showSubCategoryModal = false;
    this.subCategoryForm.reset({ status: 'Paid' });
    this.selectedFileName = null;
  }


  onSaveSubCategory() {
    if (this.subCategoryForm.valid) {

      const existingFile =
        this.sections[this.selectedSectionIndex]
          ?.expense[this.selectedExpenseIndex]?.attach;

      const newExpense = {
        ...this.subCategoryForm.value,
        attach: this.selectedFileName || existingFile || 'No File'
      };

      if (this.isEditMode) {
        this.sections[this.selectedSectionIndex]
          .expense[this.selectedExpenseIndex] = newExpense;
      } else {
        this.sections[this.selectedSectionIndex]
          .expense.push(newExpense);
      }

      this.toggleSubCategoryModal();
    }
  }


  deleteSubCategory(sectionIndex: number, expenseIndex: number) {
    this.sections[sectionIndex].expense.splice(expenseIndex, 1);
  }

  toggleSection(index: number) {
    this.sections[index].isOpen =
      !this.sections[index].isOpen;
  }
  ngOnChanges() {
    this.showTableLoader(500);
  }
  ngOnInit(): void {
    this.showTableLoader();
  }
  skeletonRows: any[] = [];
  showTableLoader(duration = 800) {
    this.showSkeleton = true;

    const rowCount = this.sections?.length || 3;
    this.skeletonRows = Array(rowCount).fill(0);

    setTimeout(() => {
      this.showSkeleton = false;
    }, duration);
  }
}
